import { toast } from 'react-toastify'
import React, { createContext, useContext, useState, useEffect } from 'react'

import useCart from './CartProvider'
import useAuth from './AuthContext'
import * as WishlistService from '../services/WishlistService'

const WishlistContext = createContext()

export const WishlistContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false)
  const [wishlistProducts, setWishlistProducts] = useState([])

  const { fetchCart } = useCart()
  const { auth, setLoginModalShow } = useAuth()

  const fetchWishlist = () => {
    if (!auth) {
      setWishlistProducts([])
      return
    }
    setLoading(true)
    WishlistService.getWishlist()
      .then(data => {
        setWishlistProducts(data.products || [])
        setLoading(false)
      })
      .catch(() => {
        setWishlistProducts([])
        setLoading(false)
      })
  }

  const addToWishlist = (sku, variants) => {
    if (!auth) {
      setLoginModalShow(true)
      return Promise.reject('User not authenticated')
    }
    return WishlistService.addToWishlist(sku, variants).then(response => {
      toast.success('პროდუქტი წარმატებით დაემატა სურვილების სიაში')

      fetchWishlist()

      return response
    })
  }

  const moveAllToCart = () => {
    return WishlistService.moveAllToCart().then(response => {
      toast.success('ყველა პროდუქტი გადავიდა კალათაში')
      fetchWishlist()
      fetchCart()
      return response
    })
  }

  const deleteFromWishlist = sku => {
    return WishlistService.deleteFromWishlist(sku).then(response => {
      toast.info('პროდუქტი წაიშალა სურვილების სიიდან')
      fetchWishlist()
      return response
    })
  }

  const clearWishlist = () => {
    return WishlistService.clearWishlist().then(() => {
      toast.info('სურვილების სია გასუფთავდა')
      fetchWishlist()
    })
  }

  useEffect(() => {
    fetchWishlist()
  }, [auth])

  return (
    <WishlistContext.Provider
      value={{
        wishlistProducts,
        addToWishlist,
        deleteFromWishlist,
        loading,
        fetchWishlist,
        moveAllToCart,
        clearWishlist,
      }}
    >
      {children}
    </WishlistContext.Provider>
  )
}

export const useWishlistContext = () => {
  return useContext(WishlistContext)
}
